import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';

export const authGuard: CanActivateFn = () => {
  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);

  if (!tokenStorage.isLoggedIn()) {
    router.navigateByUrl('/auth/login');
    return false;
  }

  // اگر کاربر هنوز مرحله Onboarding را تکمیل/رد نکرده، حتی با وارد کردن
  // مستقیم آدرس داشبورد/تقویم/... باید اول به onboarding هدایت شود؛
  // در غیر این صورت پیش‌بینی او همچنان روی مقادیر پیش‌فرض خام می‌ماند.
  const user = tokenStorage.currentUser();
  if (user && !user.hasCompletedOnboarding) {
    router.navigateByUrl('/onboarding');
    return false;
  }

  return true;
};

/** مسیرهای auth (login/register) را اگر کاربر از قبل لاگین است، به مسیر مناسب هدایت می‌کند */
export const guestGuard: CanActivateFn = () => {
  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);

  if (!tokenStorage.isLoggedIn()) {
    return true;
  }

  const user = tokenStorage.currentUser();
  const destination = user && !user.hasCompletedOnboarding ? '/onboarding' : '/dashboard';
  router.navigateByUrl(destination);
  return false;
};

/**
 * محافظ مخصوص خود صفحه Onboarding: اگر کاربر لاگین نباشد به login می‌رود،
 * و اگر Onboarding را از قبل تکمیل کرده باشد، دیگر اجازه نمی‌دهیم دوباره
 * این صفحه را ببیند (تا داده‌های تاریخی تکراری ثبت نشود؛ سرور هم این حالت
 * را با BadRequest رد می‌کند، اما بهتر است در فرانت هم همان لحظه جلویش بگیریم).
 */
export const onboardingGuard: CanActivateFn = () => {
  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);

  if (!tokenStorage.isLoggedIn()) {
    router.navigateByUrl('/auth/login');
    return false;
  }

  const user = tokenStorage.currentUser();
  if (user?.hasCompletedOnboarding) {
    router.navigateByUrl('/dashboard');
    return false;
  }

  return true;
};
